var Chengdu = {
  pengzhou: { name: "彭州", pointPos: { x: 1943, y: 1266 }, namePos: { x: 1944, y: 1354 } },
  xindu: { name: "新都", pointPos: { x: 2253, y: 1678 }, namePos: { x: 2259, y: 1762 } },
  qingbaijiang: { name: "青白江", pointPos: { x: 2754, y: 1822 }, namePos: { x: 2761, y: 1912 } },
  jintang: { name: "金堂", pointPos: { x: 3249, y: 1957 }, namePos: { x: 3247, y: 2067 } },
  longquanyi: { name: "龙泉驿", pointPos: { x: 2679, y: 2245 }, namePos: { x: 2680, y: 2343 } },
  jianyang: { name: "简阳", pointPos: { x: 3253, y: 2566 }, namePos: { x: 3263, y: 2670 } },
  dujiangyan: { name: "都江堰", pointPos: { x: 1439, y: 1521 }, namePos: { x: 1447, y: 1611 } },
  pidu: { name: "郫都", pointPos: { x: 1825, y: 1684 }, namePos: { x: 1830, y: 1777 } },
  gaoxin1: { name: "高新", pointPos: null, namePos: { x: 2027, y: 1971 } },
  jinniu: { name: "金牛", pointPos: { x: 2214, y: 1998 }, namePos: { x: 2215, y: 2057 } },
  chenghua: { name: "成华", pointPos: { x: 2402, y: 2038 }, namePos: { x: 2401, y: 2100 } },
  wuhou: { name: "武侯", pointPos: { x: 2130, y: 2200 }, namePos: { x: 2137, y: 2259 } },
  gaoxin: { name: "高新", pointPos: { x: 2240, y: 2325 }, namePos: { x: 2255, y: 2389 } },
  tianfu: { name: "天府新区", pointPos: { x: 2349, y: 2660 }, namePos: { x: 2357, y: 2763 } },
  gaoxin3: { name: "高新", pointPos: null, namePos: { x: 2072, y: 2671 } },
  // gaoxin4: { name: "高新", pointPos: { x: 2842, y: 2838 }, namePos: { x: 2848, y: 2912 } },
  dongbuxin: { name: "成都东部新区", pointPos: { x: 2777, y: 2615 }, namePos: { x: 2777, y: 2715 } },
  pujiang: { name: "蒲江", pointPos: { x: 1188, y: 3025 }, namePos: { x: 1192, y: 3117 } },
  qionglai: { name: "邛崃", pointPos: { x: 846, y: 2707 }, namePos: { x: 840, y: 2788 } },
  chongzhou: { name: "崇州", pointPos: { x: 1503, y: 2131 }, namePos: { x: 1503, y: 2229 } },
  dayi: { name: "大邑", pointPos: { x: 830, y: 2179 }, namePos: { x: 835, y: 2271 } },
  wenjiang: { name: "温江", pointPos: { x: 1783, y: 1981 }, namePos: { x: 1782, y: 2075 } },
  shuangliu: { name: "双流", pointPos: { x: 2000, y: 2317 }, namePos: { x: 2000, y: 2417 } },
  xinjin: { name: "新津", pointPos: { x: 1808, y: 2620 }, namePos: { x: 1815, y: 2719 } },
  jinjiang: { name: "锦江", pointPos: { x: 2351, y: 2225 }, namePos: { x: 2375, y: 2284 } },
  qingyang: { name: "青羊", pointPos: { x: 2043, y: 2078 }, namePos: { x: 2130, y: 2100 } },
};
export default Chengdu;
